import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils";

export const WEB_PAGE_SURFACE_CLASS =
  "bg-[rgba(255,255,255,0.45)]";

export const WEB_PAGE_SURFACE_MD_CLASS =
  "md:bg-[rgba(255,255,255,0.45)]";

export const WEB_PAGE_SURFACE_LG_CLASS =
  "lg:bg-[rgba(255,255,255,0.45)]";

type WebPageSurfaceProps = ComponentPropsWithoutRef<"div"> & {
  testId?: string;
};

export function WebPageSurface({
  children,
  className,
  testId,
  ...props
}: WebPageSurfaceProps) {
  return (
    <div
      data-testid={testId}
      {...props}
      className={cn(WEB_PAGE_SURFACE_CLASS, className)}
    >
      {children}
    </div>
  );
}
